import React from 'react';
import './styles.scss';
import moment from 'moment';
import strings from 'utils/strings';
import {updateObject, updateItemInArray} from 'utils/reducerUtils';
import {allChildGrades, allYouthGrades, allAdultGrades} from 'constants/index';

const genders = [
	{
		label: 'Jente',
		value: 'f',
	},
	{
		label: 'Gutt',
		value: 'm',
	},

	{
		label: 'Annet',
		value: 'u',
	},
];
const yesAndno = [
	{
		label: 'Nei',
		value: 0,
	},
	{
		label: 'Ja',
		value: 1,
	},
	{
		label: strings.answerDoesNotKnow,
		value: 2,
	},
];

const now = moment();

class CandidateInfo extends React.Component {
	constructor(props) {
		super(props);
		this.updateTestUser = this.updateTestUser.bind(this);
		this.updateTestUserBirthDate = this.updateTestUserBirthDate.bind(this);
		this.state = {
			submitEnabled: true,
			isFormValid: false,
			candidateGrade: null,
			isNorming: 1,
			excludeReading: 0,
			dateIsWrong: false,
			showReadingTestOption: false,
			testUserInfo: {
				birthDate: '',
				firstName: '',
				lastName: '',
				gender: '',
				email: '',
				testDevice: '',
				isForeign: '',
				hasDifficulties: '',
				age: {
					years: 0,
					months: 0,
				},
				education: {
					youthGrade: 0,
				},
			},
		};
	}
	updateTestUser(categoryKey, key, value) {
		const {testUserInfo} = this.state;

		if (categoryKey) {
			const category = updateObject(testUserInfo[categoryKey], {
				[key]: value,
			});

			this.setState({
				testUserInfo: updateObject(testUserInfo, {
					[categoryKey]: category,
				}),
			});
		} else if (
			key === 'education' &&
			[2, 3, 4].includes(Number(value.youthGrade))
		) {
			this.setState({
				testUserInfo: updateObject(testUserInfo, {
					[key]: value,
				}),
				showReadingTestOption: true,
			});
		} else if (
			key === 'education' &&
			![2, 3, 4].includes(Number(value.youthGrade))
		) {
			this.setState({
				testUserInfo: updateObject(testUserInfo, {
					[key]: value,
				}),
				showReadingTestOption: false,
				excludeReading: 0,
			});
		} else {
			this.setState({
				testUserInfo: updateObject(testUserInfo, {
					[key]: value,
				}),
			});
		}
	}

	updateTestUserBirthDate(key, value, keyBirth, valBirth) {
		const {testUserInfo} = this.state;
		this.setState({
			testUserInfo: updateObject(testUserInfo, {
				[key]: value,
				[keyBirth]: valBirth,
			}),
		});
	}
	sendCodeAndInfoUsingEmail = (event, testUser, pin) => {
		event.preventDefault();
		const {age} = testUser;
		if (age.years < 3 || age.years > 90) {
			this.setState({dateIsWrong: true});
			return;
		}
		const {id, testKey, pinCode, type} = this.props.infoPanelTestKey;
		const isNorming = this.state.isNorming;
		const excludeReading = this.state.excludeReading;
		const {processTestResults, testResults} = this.props;

		const nextTestResults = updateItemInArray(
			testResults,
			id,
			(currentTestResult) =>
				updateObject(currentTestResult, {
					distributedAt: moment(),
				})
		);
		const nextBatchedTestResults = processTestResults(nextTestResults);

		this.props.onDistributeKeyAndStoreInfo(
			isNorming,
			testKey,
			testUser,
			excludeReading,
			pin
		);
	};

	returnInstruction(testType) {
		const type = testType.replace('-screening', '');
		switch (type) {
			case 'youth':
				return strings.formatString(
					strings.normingCommenceInstructions1,
					strings.screeningTestYouthName
				);
			case 'child':
				return strings.formatString(
					strings.normingCommenceInstructions1,
					strings.screeningTestChildName
				);
			case 'adult':
				return strings.formatString(
					strings.normingCommenceInstructions1,
					strings.screeningTestAdultName
				);

			default:
				return strings.formatString(
					strings.normingCommenceInstructions1,
					strings.screeningTestChildName
				);
		}
	}
	returnRelevantLabel(testType, c) {
		const type = testType.replace('-screening', '');
		if (c === 'main') {
			switch (type) {
				case 'youth':
					return strings.classGrade;
				case 'child':
					return strings.classGrade;
				case 'adult':
					return strings.educationLevel;
				default:
					return strings.classGrade;
			}
		} else {
			switch (type) {
				case 'youth':
					return strings.selectGradePlaceholder;
				case 'child':
					return strings.selectGradePlaceholder;
				case 'adult':
					return strings.selectEducationLevelPlaceholder;
				default:
					return strings.selectGradePlaceholder;
			}
		}
	}
	returnRelevantGrades(testType) {
		const type = testType.replace('-screening', '');
		switch (type) {
			case 'youth':
				return allYouthGrades;
			case 'child':
				return allChildGrades;
			case 'adult':
				return allAdultGrades;

			default:
				return allChildGrades;
		}
	}
	render() {
		const {isFormValid, testUserInfo} = this.state;
		const {pinCode, testKey: keyLable, type} = this.props.infoPanelTestKey;

		const {email, gender, isForeign, hasDifficulties} = testUserInfo;
		let formRef;

		const {testResults} = this.props;
		const {id, key: testKey, testUser} = testResults;

		let firstName;
		let lastName;
		let fullName;

		if (testUser) {
			email = testUser.email;
			firstName = testUser.firstName;
			lastName = testUser.lastName;
			fullName = `${firstName} ${lastName}`;
		}

		return (
			<div
				className="lit-modal-candidate"
				onClick={() => {
					this.props.closeWindow();
				}}
			>
				<div
					className="lit-modal__continent-norming"
					onClick={(event) => {
						event.stopPropagation();
					}}
				>
					<div
						style={{
							width: '85%',
							margin: 'auto',
						}}
					>
						<div
							className="lit-candidate-info"
							onClick={() => {
								this.props.closeWindow();
							}}
						>
							<div
								className="lit-candidate-container"
								onClick={(event) => {
									event.stopPropagation();
								}}
							>
								<form
									className="lit-input-candidate"
									onChange={() => {
										const formValidity =
											formRef.checkValidity();

										if (
											isFormValid !== formValidity &&
											!this.state.dateIsWrong
										) {
											this.setState({
												isFormValid: formValidity,
											});
										}
									}}
									onSubmit={(e) => {
										e.preventDefault();
										this.sendCodeAndInfoUsingEmail(
											e,
											this.state.testUserInfo,
											pinCode
										);
									}}
									ref={(ref) => {
										formRef = ref;
									}}
								>
									<div className="lit-info__main-container">
										<div className="lit-info__main-container__wrapper1">
											<div className="lit-info__field">
												<h3
													className="lit-candidate-info-header__bolder"
													style={{
														fontSize: '15px',
														color: 'black',
														fontWeight: 'bold',
														padding: '10px',
													}}
												>
													{
														strings.candidateInfoHeadingLine1
													}
													<br />
													{
														strings.candidateInfoHeadingLine2
													}
												</h3>
												<div className="lit-norming-candidate-label">
													<label
														className="lit-test__heading"
														htmlFor={`firstName`}
													>
														{strings.firstname}
													</label>
													<div>
														<input
															className="lit-input__field"
															id={`firstName-${id}`}
															name={`firstName`}
															placeholder="Ola"
															onChange={(
																event
															) => {
																this.updateTestUser(
																	null,
																	'firstName',
																	event.target
																		.value
																);
															}}
															required
															type="text"
														/>
													</div>
												</div>
												<div className="lit-norming-candidate-label">
													<label
														className="lit-test__heading"
														htmlFor={`lastName`}
													>
														{strings.lastname}
													</label>
													<div>
														<input
															className="lit-input__field"
															id="email"
															name="lastName"
															placeholder="Lukas"
															onChange={(
																event
															) => {
																const value =
																	event.target
																		.value;
																this.updateTestUser(
																	null,
																	'lastName',
																	value
																);
															}}
															required
															type="text"
														/>
													</div>
												</div>
												{/* <div className="lit-norming-candidate-label">
													<label
														className="lit-test__heading"
														htmlFor={`email`}
													>
														{strings.email}
													</label>
													<div>
														<input
															className="lit-input__field"
															id={`email${id}`}
															name={`email`}
															placeholder="ola@epost.no"
															onChange={(
																event
															) => {
																this.updateTestUser(
																	null,
																	'email',
																	event.target
																		.value
																);
															}}
															type="email"
														/>
													</div>
												</div> */}
											</div>

											<div className="lit-info__field">
												<div className="lit-candidate-label-gender">
													<label className="lit-test__heading">
														{strings.gender}
													</label>
													<div className="lit-input__field">
														{genders.map(
															(genderOption) => {
																const {
																	label: genderLabel,
																	value,
																} =
																	genderOption;

																return (
																	<span
																		className="lit-radio"
																		key={
																			value
																		}
																	>
																		<input
																			checked={
																				value ===
																				gender
																			}
																			className="lit-radio__field"
																			id={`gender${value}`}
																			name="gender"
																			onChange={() => {
																				this.updateTestUser(
																					null,
																					'gender',
																					value
																				);
																			}}
																			required
																			type="radio"
																		/>
																		<label
																			className="lit-radio__label"
																			htmlFor={`gender${value}`}
																		>
																			{
																				genderLabel
																			}
																		</label>
																	</span>
																);
															}
														)}
													</div>
												</div>
											</div>

											<div className="lit-info__field">
												{!type.includes('adult') && (
													<div className="lit-candidate-label-gender">
														<label className="lit-test__heading">
															{
																strings.candidateFirstLanguageQuestion
															}
														</label>
														<div className="lit-input__field">
															{yesAndno.map(
																(
																	genderOption
																) => {
																	const {
																		label: genderLabel,
																		value,
																	} =
																		genderOption;

																	return (
																		<span
																			className="lit-radio"
																			key={
																				value
																			}
																		>
																			<input
																				checked={
																					value ===
																					isForeign
																				}
																				className="lit-radio__field"
																				id={`isForegin${value}`}
																				name="isForeign"
																				onChange={() => {
																					this.updateTestUser(
																						null,
																						'isForeign',
																						value
																					);
																				}}
																				required
																				type="radio"
																			/>
																			<label
																				className="lit-radio__label"
																				htmlFor={`isForeign${value}`}
																			>
																				{
																					genderLabel
																				}
																			</label>
																		</span>
																	);
																}
															)}
														</div>
													</div>
												)}
											</div>

											<div className="lit-info__field">
												{!type.includes('adult') && (
													<div className="lit-candidate-label-gender">
														<label className="lit-test__heading">
															{
																strings.candidateDifficultiesQuestion
															}
														</label>

														<div className="lit-input__field">
															{yesAndno.map(
																(
																	genderOption
																) => {
																	const {
																		label: genderLabel,
																		value,
																	} =
																		genderOption;

																	return (
																		<span
																			className="lit-radio"
																			key={
																				value
																			}
																		>
																			<input
																				checked={
																					value ===
																					hasDifficulties
																				}
																				className="lit-radio__field"
																				id={`isForegin${value}`}
																				name="hasDifficulties"
																				onChange={() => {
																					this.updateTestUser(
																						null,
																						'hasDifficulties',
																						value
																					);
																				}}
																				required
																				type="radio"
																			/>
																			<label
																				className="lit-radio__label"
																				htmlFor={`hasDifficulties${value}`}
																			>
																				{
																					genderLabel
																				}
																			</label>
																		</span>
																	);
																}
															)}
														</div>
													</div>
												)}
											</div>

											<div className="lit-info__field">
												<div className="lit-norming-candidate-label">
													<label
														className="lit-test__heading"
														htmlFor={`age`}
													>
														{strings.birthDate}
													</label>
													<div className="lit-input__field">
														<input
															type="date"
															placeholder="dd-mm-yyyy"
															name="age"
															onChange={(
																event
															) => {
																const numberOfMonths = 12;
																const value =
																	event.target
																		.value;

																const age = {
																	years: now.diff(
																		value,
																		'years'
																	),
																	months:
																		now.diff(
																			value,
																			'months'
																		) %
																		numberOfMonths,
																};
																if (
																	age.years >
																		2 &&
																	age.years <
																		90
																) {
																	this.setState(
																		{
																			dateIsWrong: false,
																		}
																	);
																} else {
																	this.setState(
																		{
																			dateIsWrong: true,
																		}
																	);
																}
																this.updateTestUserBirthDate(
																	'age',
																	age,
																	'birthDate',
																	value
																);
															}}
															required
														/>
													</div>
													{this.state.dateIsWrong && (
														<span
															style={{
																color: 'Red',
																fontSize:
																	'14px',
															}}
														>
															<i>
																{
																	strings.validation_birthDateInvalid
																}
															</i>
														</span>
													)}
												</div>

												<div className="lit-candidate-label-grade">
													<label className="lit-test__heading">
														{this.returnRelevantLabel(
															type,
															'main'
														)}
													</label>
													<div>
														<select
															className="lit-input__field-trinn"
															id={`email-invite-${id}`}
															name={`youthGrade`}
															required="required"
															onChange={(
																event
															) => {
																const education =
																	{
																		youthGrade:
																			event
																				.target
																				.value,
																	};
																this.updateTestUser(
																	null,
																	'education',
																	education
																);
															}}
														>
															<option
																id={0}
																key={0}
																value=""
																disabled
																selected
															>
																{this.returnRelevantLabel(
																	type,
																	false
																)}
															</option>
															{this.returnRelevantGrades(
																type
															).map((grades) => (
																<option
																	id={
																		grades.id
																	}
																	key={
																		grades.id
																	}
																	value={
																		grades.value
																	}
																>
																	{
																		grades.label
																	}
																</option>
															))}
														</select>
													</div>
												</div>
											</div>

											<div className="lit-info__field">
												<div className="lit-candidate-label-pin-key">
													<label className="lit-test__heading">
														{strings.pinCode}
													</label>
													<div className="lit-input__field">
														<span className="lit-candidate-pin">
															{pinCode
																? pinCode
																: strings.hiddenValue}
														</span>
													</div>
												</div>
												<div className="lit-candidate-label-pin-key">
													<label className="lit-test__heading">
														{strings.testkey}
													</label>
													<div className="lit-input__field">
														<span className="lit-candidate-pin">
															{keyLable}
														</span>
													</div>
												</div>
											</div>
										</div>

										<div className="lit-info__main-container__wrapper2">
											<div className="lit-info__field-text">
												<p>
													{
														strings.testCandidateTakeTestWith
													}
												</p>
												<li>
													{strings.gotoDysmtateSite}
												</li>
												<li>
													{this.returnInstruction(
														type
													)}
												</li>
												<li>
													{
														strings.testCommenceInstructions2
													}
												</li>
												<li>
													{
														strings.loginWithPinCodeInstruction
													}
												</li>
												<br />
												{/* 
												<p>
													{
														strings.testCommenceInstructions5
													}
												</p> */}
											</div>

											<div className="lit-info__field-fifth">
												<div>
													<span className="lit-fill-out-info-consent">
														<input
															type="checkbox"
															name="agreedToPrivacyPolicy"
															required
															className="user_checkbox2"
														/>{' '}
														{strings.iConsent}
													</span>
													<br />

													{strings.formatString(
														strings.constTestChild,
														<a
															target="_blank"
															rel="noopener noreferrer"
															href="https://literate.no/personvernerklaering/"
														>
															<u>
																{
																	strings.privacyPolicy
																}
															</u>
														</a>
													)}
												</div>
												<div className="lit-btn-submit-from">
													<button
														className={
															isFormValid
																? 'lit-btn lit-btn bg-primary-glow'
																: 'lit-btn lit-btn bg-primary-dark'
														}
														onClick={() => {}}
													>
														{strings.sendtest}
													</button>
												</div>
											</div>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default CandidateInfo;
